import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUserDetailsAPI } from "../Store/Action/UserAction";

const PrivateRoute = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  // const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const { isLoggedIn, user } = useSelector((state) => state.authSlice);
  const [loggedInUser, setLoggedInUser] = useState([]);
  const [userOnboardingStatus, setUserOnboardingStatus] = useState("");
  const [isFlagOnboarded, setIsFlagOnboarded] = useState(null);
  const [hasSubscription, setHasSubscription] = useState([]);
  // const isOnboarded = user?.onboardingCompleted || false;
  // const isOnboarded = useSelector(
  //   (state) => state.onboarding?.isOnboarded ?? false
  // );
  const isOnboarded = useSelector(
    (state) => state.onboardingSlice?.isOnboarded ?? false
  );

  // const isRefillingOnboarding = localStorage.getItem(
  //   "isRefillingOnboardingForm"
  // );

  // const isRefillingOnboardingFormIsNowInReviewed = localStorage.getItem(
  //   "isRefillingOnboardingFormIsNowInReviewed"
  // );
  // const isRefillingOnboarding = JSON.parse(
  //   localStorage.getItem("isRefillingOnboardingForm") || false
  // );

  const isRefillingOnboardingFormIsNowInReviewed = JSON.parse(
    localStorage.getItem("isRefillingOnboardingFormIsNowInReviewed") || "false"
  );
  // const flagOnboarded = localStorage.getItem("flagOnboarded");

  // const freshUserVisits = location?.state?.freshUserVisits;

  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        if (result?.status) {
          setLoggedInUser(result?.data);
          setUserOnboardingStatus(result?.data?.[0]?.user_status_name);
          setIsFlagOnboarded(result?.data?.[0]?.user_flag_onboard);
          setHasSubscription(result?.data?.[0]?.user_subscription);
        }
      })
    );
  }, [dispatch, isOnboarded, isLoggedIn]);

  if (isLoggedIn) {
    // if (!isRefillingOnboarding) {
    // if (freshUserVisits) {
    //   const allowedPath = ["/profile-under-review"];
    //   if (!allowedPath.includes(location.pathname)) {
    //     return <Navigate to="/profile-under-review" replace />;
    //   }
    // } else

    if (userOnboardingStatus == "pending verification") {
      const allowedPath = ["/onboarding", "/about-us"];
      if (!allowedPath.includes(location.pathname)) {
        return <Navigate to="/onboarding" replace />;
      }
    } else if (userOnboardingStatus == "approved") {
      const notAllowedPath = [
        "/login",
        "/login/",
        "/onboarding",
        "/onboarding/",
        // "/",
        "/profile-under-review",
        "/profile-pending",
        "/profile-not-approved",
      ];

      if (notAllowedPath.includes(location.pathname)) {
        return <Navigate to="/home" replace />;
      }
    } else if (userOnboardingStatus == "in reviewed") {
      const allowedPath = [
        "/profile-under-review",
        "/profile-pending",
        "/",
        "/inquiry-form",
        "/subscriptionPlan",
        "/contact-us",
        "/about-us",
        "/login",
      ];
      if (!allowedPath.includes(location.pathname)) {
        return <Navigate to="/profile-under-review" replace />;
      }
    } else if (!isRefillingOnboardingFormIsNowInReviewed) {
      if (userOnboardingStatus == "rejected") {
        const allowedPath = [
          "/profile-not-approved",
          "/onboarding",
          "/",
          "/inquiry-form",
          "/subscriptionPlan",
          "/contact-us",
          "/about-us",
          "/login",
        ];
        if (!allowedPath.includes(location.pathname)) {
          return <Navigate to="/profile-not-approved" replace />;
        }
      }
    }

    // else if (userOnboardingStatus == "in reviewed") {
    //   const allowedPath = ["/profile-under-review", "/profile-pending"];
    //   if (!allowedPath.includes(location.pathname)) {
    //     return <Navigate to="/profile-under-review" replace />;
    //   }
    // }

    //check is user completed the onboarding or not----------------------------------------------------------------
    // if (!user?.onboardingCompleted) {

    //   const allowedPath = ["/onboarding"];
    //   if (!allowedPath.includes(location.pathname)) {
    //     return <Navigate to="/onboarding" replace />;
    //   }
    // return <Navigate to="/onboarding" replace />;
    // } else {
    //check user onboarding status ------------------------------------------------------------------------------ (need to handle test scenarios)
    // if (userOnboardingStatus == "approved") {
    //   return <Navigate to="/" replace />;
    // }
    // }
    // const notAllowedPath = ["/login", "/login/"];

    // if (notAllowedPath.includes(location.pathname)) {
    //   return <Navigate to="/" replace />;
    // }
    // }
  }
  // Handle redirection for users who haven't logged in -----------------------------------
  if (!isLoggedIn) {
    const { state } = location;
    // if (state?.fromAdmin) {
    //
    //   return <Navigate to="/admin/login" replace />;
    // }

    const allowedPath = [
      "/login",
      "/about-us",
      "/contact-us",
      "/subscriptionPlan",
      "/inquiry-form",
      "/",
    ];
    if (!allowedPath.includes(location.pathname)) {
      return <Navigate to="/" replace />;
    }
  }

  // Set up redirection for users who are logged in -----------------------------------

  // if (isOnboarded) {
  //   if (loggedInUser?.[0]?.user_status_name === "approved") {
  //
  //     return <Navigate to="/" replace />;
  //   } else if (loggedInUser?.[0]?.user_status_name === "rejected") {

  //     return <Navigate to="/profile-not-approved" replace />;
  //   }

  //   return <Navigate to="/profile-under-review" replace />;
  // }

  // if (isOnboarded) {

  //   if (user?.user_status_name === "approved") {
  //
  //     return <Navigate to="/" replace />;
  //   } else if (user?.user_status_name === "rejected") {
  //
  //     return <Navigate to="/profile-not-approved" replace />;
  //   }

  //   return <Navigate to="/profile-under-review" replace />;
  // }

  // Check if token expiry time is valid and compare with the current time
  const tokenExpiryTime = user?.user_details?.user_token_expiry_time
    ? new Date(user.user_details.user_token_expiry_time).getTime()
    : null;

  if (tokenExpiryTime && tokenExpiryTime < Date.now()) {
    return <Navigate to="/login" replace />;
  } else {
  }
  return <Outlet />;
};

export default PrivateRoute;
